//      
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Form } from 'formik';

import {                } from 'types/api';
import { CenterBox } from './utils';

import { post } from 'api';

import { chainValidators, isRequired, isEmail } from 'utils/formHelpers';
import { Alert, Col } from 'bs';
import { Input } from 'components/FormikFields';
import Icon from 'components/Icon';
import SubmitButton from 'components/SubmitButton';
import CancelButton from 'components/CancelButton';

const requestPasswordReset = (email        , callbacks           ) => {
    const { start, done, fail } = callbacks;
    start();
    const path = 'user/request-reset/';
    post(path, { email })
        .then(data => done(data))
        .catch(error => fail(error));
};

              
                       
  

class RequestPasswordReset extends Component        {
    state = {
        requestComplete: false,
        email: null,
    };

    render() {
        const { goHome } = this.props;
        const { requestComplete, email } = this.state;

        const setRequestComplete = (email) => this.setState({ requestComplete: true, email: email });

        const ERROR_429 = 'Too many reset attempts. Please wait and try again later.';

        if (requestComplete) {
            return (
                <CenterBox>
                    <Col id='request-password-reset-success'>
                        <h2 className='text-success'>
                            <Icon name='paper-plane' className='mr-2' /> Email sent!
                        </h2>
                        <p>
                            If <code>{email}</code> matches an account in our system,
                            an email with a link to reset your password will be sent.
                            Click the link  to reset your password.
                        </p>
                    </Col>
                </CenterBox>
            );
        }

        const form = (
            <Formik
                initialValues={{ email: '' }}
                onSubmit={({ email }, actions) => {
                    const callbacks = {
                        start: () => {
                            actions.setSubmitting(true);
                            actions.setStatus(null);
                        },
                        done: () => {
                            actions.setSubmitting(false);
                            setRequestComplete(email);
                        },
                        fail: error => {
                            let message = "Something went wrong. Please try again later.";

                            actions.setSubmitting(false);
                            if (error.status === 429) {
                                message = ERROR_429;
                            }
                            actions.setStatus(message);
                        },
                    };
                    requestPasswordReset(email, callbacks);
                }}
            >
                {({ isValid, status, isSubmitting }) => (
                    <Form id='request-password-reset-form'>
                        {status && (
                            <>
                                <Alert flavor='danger'>{status}</Alert>
                                <Alert flavor='info'>Having an issue resetting your password?<br/><Link to='/support'>Submit a support request.</Link></Alert>
                            </>
                        )}
                        <h2>Reset your password</h2>
                        <p className='mb-4'>
                            Provide the email associated with your account and we'll
                            send you an email with a link to reset your password.
                        </p>
                        <Input
                            type='text'
                            name='email'
                            label='Email Address'
                            validate={chainValidators(isRequired, isEmail)}
                        />

                        <SubmitButton
                            id='request-password-reset-submit'
                            disabled={!isValid}
                            submitting={isSubmitting}
                        />
                        <CancelButton onClick={goHome} />
                    </Form>
                )}
            </Formik>
        );

        return <CenterBox>{form}</CenterBox>;
    }
}

export default RequestPasswordReset;
